import { render, staticRenderFns } from "./MainSettings.vue?vue&type=template&id=12dc4c34&scoped=true&"
import script from "./MainSettings.vue?vue&type=script&lang=js&"
export * from "./MainSettings.vue?vue&type=script&lang=js&"
import style0 from "./MainSettings.vue?vue&type=style&index=0&id=12dc4c34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc4c34",
  null
  
)

export default component.exports